import { useWinController } from "./useWinController";
import { useFreeSpinWinController } from "./useFreeSpinWinController";
import { useHoldAndWinCollectionController } from "./useHoldAndWinCollectionController";

const HookImport = () => {
  useWinController();
  useFreeSpinWinController();
  useHoldAndWinCollectionController();
  return null;
};

export default HookImport;
